import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Dropdown, Button, Icon} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {dealerList} from '../../../common/constants/lists';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import FiltersSectionMultiple from '../../../common/components/dateFilterMultiple/dateFiltersSectionMultiple';
import ReportQuotes from './ReportQuotes';
import DataTable from './dataTable';
import WalkIn from './walkIn';
import './dailyVehiclesSales.scss';

const years = [{
  'year': 2019,
}, {
  'year': 2020,
}, {
  'year': 2021,
}, {
  'year': 2022,
}, {
  'year': 2023,
}, {
  'year': 2024,
}, {
  'year': 2025,
}, {
  'year': 2026,
}];

class DailyVehiclesSalesAndStockReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showDefaultValues': true,
      'clientTmp': '',
      'clientSelected': '',
      'agencyTmp': '',
      'agencySelected': '',
      'dateFilters': {},
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
      'showWalkInTable': false,
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.DailyVehiclesSalesAndStockReport, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchDealers('importers');
    this.props.fetchVehiclesModel();
  }

  renderWalkInTable = () => {
    const {showWalkInTable} = this.state;

    if (showWalkInTable) {
      return <WalkIn filters={this.getFilters() } />;
    }
    return null;
  }

  onClearFilters = () => {
    this.setState({
      'showDefaultValues': true,
      'clientTmp': '',
      'clientSelected': '',
      'agencyTmp': '',
      'agencySelected': '',
      'dateFilters': {},
      'clearFilters': {
        'year': false,
        'month': false,
        'day': true,
      },
      'showWalkInTable': false,
    });
  }

  onDownloadClick = () => {
    const filters = this.getFilters();
    this.props.downloadDailyVehiclesSales(filters);
  }

  onSearchClick = () => {
    const filters = this.getFilters();
    this.props.fetchDailyVehiclesSales(filters);
    this.setState({'showDefaultValues': false, 'showWalkInTable': true});
  }

  getFilters = () => {
    const {clientSelected, agencySelected, dateFilters} = this.state;
      
    const filters = {};
    if (clientSelected && clientSelected !== 'all') {
      filters.clientId = clientSelected;
    }
    if (agencySelected && agencySelected !== 'all') {
      filters.agency = agencySelected;
    }
    if (dateFilters) {
      filters.startDate = dateFilters.startDate;
      filters.endDate = dateFilters.endDate;
    }
    return filters;
  }

  getClients = () => {
    return this.props.clients.map((dealer) => {
      return {'text': dealer.name, 'value': dealer.identification};
    });
  }
  
  getAgencies = () => {
    const agencies = this.props.agencies.map((element) => {
      return {'text': element.name, 'value': element.code};
    });
    agencies.unshift({'text': 'TODAS LAS AGENCIAS', 'value': 'all'});
    return agencies;
  }

  updateSearchFilters = (value, filterName) => {
    const newState = {'showDefaultValues': true};
    newState[filterName] = value;
    this.setState(newState, () => {
      if (filterName === 'agencyTmp') {
        this.updateDataForAgency();
      } else if (filterName === 'clientTmp') {
        this.updateDataForClient();
      }
    });
  }

  updateDataForClient = () => {
    const {clientSelected, clientTmp} = this.state;
    if (clientSelected === clientTmp) {
      return;
    }
    this.updateSearchFilters(clientTmp, 'clientSelected');
    this.updateSearchFilters('', 'agencyTmp');
    this.updateSearchFilters('', 'agencySelected');
    this.updateSearchFilters(false, 'showWalkInTable');
    this.props.fetchAgenciesByDealer({'dealerId': clientTmp, 'salesReport': 'S'});
  }

  updateDataForAgency = () => {
    const {agencySelected, agencyTmp} = this.state;
    if (agencySelected === agencyTmp) {
      return;
    }
    this.updateSearchFilters(agencyTmp, 'agencySelected');
  }

  onUpdateDateFiltersClick = (dateFilters) => {
    this.setState({
      dateFilters,
      'showDefaultValues': true,
      'showWalkInTable': false,
      'clearFilters': {
        'year': false,
        'month': false,
        'day': false,
      },
    });
  }

  render() {
    const {clearFilters, clientTmp, agencyTmp, showDefaultValues} = this.state;
    const {downloading, loadingClients, loadingAgencies, loadingModels, loadingSales} = this.props;

    return (
      <div className='daily-vehicles-sales-report'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Ventas y Stock diario de Vehículos</h2>
              <div className='title-bar-actions'>
                <Button
                  secondary
                  disabled={loadingAgencies || loadingModels || loadingSales || downloading}
                  loading={downloading}
                  onClick={this.onClearFilters}
                >
                  <span>Limpiar</span>
                </Button>
                <Button
                  primary
                  className='download'
                  disabled={loadingAgencies || loadingModels || loadingSales || downloading}
                  loading={downloading}
                  onClick={this.onDownloadClick}
                >
                  <Icon name='download' />
                  <span>Excel</span>
                </Button>
                <Button
                  type='button'
                  primary
                  className='toyota-primary'
                  disabled={loadingAgencies || loadingModels || loadingSales || downloading}
                  onClick={this.onSearchClick}
                >
                  Buscar
                </Button>
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row>
                  <Grid.Column width={1}>
                    <h4>Cliente</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown selection
                      options={dealerList}
                      search
                      value={clientTmp}
                      disabled={loadingClients || loadingModels || loadingSales || downloading}
                      loading={loadingClients}
                      onChange={(e, {value}) => this.updateSearchFilters(value, 'clientTmp')}
                      placeholder='Clientes'
                      noResultsMessage='Cliente no encontrado'
                    />
                  </Grid.Column>
                  <Grid.Column width={1}>
                    <h4>Agencia</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown selection
                      options={this.getAgencies()}
                      search
                      value={agencyTmp}
                      disabled={loadingAgencies || !clientTmp || clientTmp === 'all' || loadingModels ||
                        loadingSales || downloading}
                      loading={loadingAgencies}
                      onChange={(e, {value}) => this.updateSearchFilters(value, 'agencyTmp')}
                      placeholder='Agencias'
                      noResultsMessage='Agencia no encontrada'
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row textAlign='center'>
                  <Grid.Column width={16}>
                    <FiltersSectionMultiple years={years} clearFilters={clearFilters}
                      onDateFiltersClick={this.onUpdateDateFiltersClick} showDays={true} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>

        <DataTable showDefaultValues={showDefaultValues} clientTmp={clientTmp} />
        <ReportQuotes showDefaultValues={showDefaultValues}/>

        {this.renderWalkInTable()}
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingClients': state.dealer.loading,
    'clients': state.dealer.list,
    'loadingAgencies': state.dealer.loadingAgencies,
    'agencies': state.dealer.agenciesList,
    'loadingModels': state.vehiclesModels.loading,
    'loadingSales': state.dailyVehiclesSalesAndStock.loadingSales,
    'downloading': state.dailyVehiclesSalesAndStock.downloading,
    'permissions': state.session.permissions,
  };
};

const {
  navigateTo,
  fetchDealers,
  fetchAgenciesByDealer,
  fetchVehiclesModel,
  fetchDailyVehiclesSales,
  downloadDailyVehiclesSales,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  fetchDealers,
  fetchAgenciesByDealer,
  fetchVehiclesModel,
  fetchDailyVehiclesSales,
  downloadDailyVehiclesSales,
})(DailyVehiclesSalesAndStockReport);
